import { Component, Pipe, PipeTransform, Injectable, ElementRef, ViewChild, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
//import { routing } from './../../router/router';
import { AuthServiceGuest } from './../../services/AuthServiceGuest';
import { LanguageService } from './../../services/LanguageService';
import { LanguageConstants } from './../../common/language/LanguageConstants';
import { CurrentUser } from '../../dataTypes/CurrentUser';
import { versionUpdatesVerifierService } from '../../shared/services/versionUpdatesVerifier.service';



@Component({
  selector: 'LoginComponent',
  templateUrl: './LoginComponent.html',
})

export class LoginComponent implements OnInit, DoCheck {
  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>;

  public language: string = 'en';
  public languageConstants = LanguageConstants['en'];
  public error: boolean = false;
  public username: string;
  public password: string;
  check: string = '';
  captcha: number;
  public usernameError: boolean;
  public passwordError: boolean;
  public usernameFilled: boolean;
  public passwordFilled: boolean;
  public submitting: boolean;
  public _isLoginError: string;
  isDisabled: boolean = false;
  isValidNumber: boolean = false;
  answer!: number;

  public _user: CurrentUser;

  public static isGlobalMobile: any; 
  public isMobile: boolean;

  //@ViewChild("userNameEl",)
  //set userNameEl(_input: ElementRef | undefined) {
  //  if (_input !== undefined) {
  //    setTimeout(() => {
  //      this._renderer.invokeElementMethod(_input.nativeElement, "focus");
  //    }, 0);
  //  }
  //}

  constructor(
    private _router: Router,
    private _AuthService: AuthServiceGuest,
    private _language: LanguageService,
    //private _renderer: Renderer,

    private _versionUpdatesVerifierService: versionUpdatesVerifierService,
  ) {
    this._language.language$.subscribe(
      language => {
        this.language = language;
        this.languageConstants = LanguageConstants[this.language];
      });



  }

  ngOnInit(): void {

    this.createCaptcha();
  }

  createCaptcha() {
    const ctx = this.canvas.nativeElement.getContext('2d');
    const [numOne, numTwo] = [random(), random()];
    this.answer = numOne + numTwo;

    ctx!.font = '18px Arial';
    ctx!.fillText(`  ${numOne} + ${numTwo} = `, 85, 43);
  }

  ngDoCheck(): void {
    if (this.check !== '' || this.captcha !== this.answer) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
    this.captcha !== this.answer ? this.isValidNumber = true : this.isValidNumber = false;
  }

  usernameClicked() {
    this.usernameError = false;
    this.usernameFilled = false;
  }

  passwordClicked() {
    this.passwordError = false;
    this.passwordFilled = false;
  }

  usernameBlur() {
    if (!this.username) {
      this.usernameError = true;
      this.usernameFilled = false;
    } else {
      this.usernameError = false;
      this.usernameFilled = true;
    }
  }

  passwordBlur() {
    if (!this.password) {
      this.passwordError = true;
      this.passwordFilled = false;
    } else {
      this.passwordError = false;
      this.passwordFilled = true;
    }
  }

  onLogin() {

    let check = true;
    if (!this.username) {
      this.usernameError = true;
      check = false;
    }
    if (!this.password) {
      this.passwordError = true;
      check = false;
    }
    if (!check) {
      return;
    }

    const self = this;


    this.submitting = true;


    this._AuthService.login(this.username, this.password)
      .subscribe(
        (response: Response) => {

          const timestampLogin = new Date().getTime();
          self._AuthService.authToken.next(response["access_token"]);
          self._AuthService.timestampLogin = timestampLogin;


          localStorage.setItem('auth_token', response["access_token"]);
          localStorage.setItem('timestampLogin', timestampLogin + '');
          localStorage.setItem('expire', response[".expires"] + '');
          localStorage.setItem('userName', response['userID']);
          localStorage.setItem('userFirstName', response["userName"]);
          localStorage.setItem('companyName', response["companyName"]);
          localStorage.setItem('companyCode', response["companyCode"] + '');
          localStorage.setItem('allowDelete', response["allowDelete"]);
          localStorage.setItem('visibiltyPermissions', response["visibiltyPermissions"]);
          localStorage.setItem('AllowEditGuestEndDate', response["AllowEditGuestEndDate"]);
          localStorage.setItem('incrementEndDateByOneDay', response["incrementEndDateByOneDay"]);
          localStorage.setItem('guestValidateIdentityNumber', response["guestValidateIdentityNumber"]);

          localStorage.setItem('permission', response["permission"]);


          const user = new CurrentUser(
            response['userID'],// id
            response["userName"],// first name
            [],
            response["companyName"],
            response["companyCode"],
            response["allowDelete"],
            response["visibiltyPermissions"],
            response["AllowEditGuestEndDate"],
            response["incrementEndDateByOneDay"],
            response["guestValidateIdentityNumber"],
            parseInt(response["permission"], 10));

          this._AuthService.notifyUserLoggedIn(user);

          this.submitting = false;
          this.error = false;
          this._AuthService.init(true);

          self._user = self._AuthService.getUserInfo();

          if (self._user) {

            if (self._user.visibiltyPermissions === 1 || self._user.visibiltyPermissions === 0) {
              self._router.navigateByUrl('/guest');
            }
            else if (self._user.visibiltyPermissions === 2 || self._user.visibiltyPermissions === 0) {
              self._router.navigateByUrl('/subscriber');
            }

            this._versionUpdatesVerifierService.initVersionCheck();

          }



        },
        error => {
          this.submitting = false;
          this.error = true;
          this._isLoginError = 'The_username_or_password_is_incorrect';
        });


    //this._AuthService.login(this.username, this.password).subscribe((result) => {
    //  if (result === true) {
    //    this.error = false;
    //    this._AuthService.init(true);
    //  } else {
    //    this.submitting = false;
    //    this.error = true;
    //  }
    //},
    //  (error) => {
    //    this.submitting = false;
    //    this.error = true;
    //  });
  }


  goBack(): void {
    window.history.back();
  }
}

export const IS_MOBILE = () => LoginComponent.isGlobalMobile;

function random() {
  return Math.floor(Math.random() * 10) + 1;
}
